module.exports = __webpack_public_path__ + "img/benefit.b6c13f35.svg";